exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-gray[data-v-7322f58c] {\n\t\tbackground-color: #F8F9FA;\n}\n.breadcrumb-container[data-v-7322f58c] {\n\t\tborder-bottom: 1px solid #ededed;\n}\n\n/*\t.breadcrumb-item.active{\n\t\ttext-transform: capitalize;\n\t}*/\n.breadcrumb[data-v-7322f58c] {\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tbackground-color: transparent;\n}\n.breadcrumb-item + .breadcrumb-item[data-v-7322f58c]::before{\n\t\tcontent:\"\\BB\";\n}\na[data-v-7322f58c] {\n\t\tcolor: #cf0614;\n}\n\n", ""]);

// exports
